import * as React from 'react';
import {cn} from '@/lib/utils';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({size = 'md', className, ...props}, ref) => {
    const sizeClasses = {
      sm: 'w-4 h-4',
      md: 'w-6 h-6',
      lg: 'w-8 h-8',
    };

    return (
      <div
        ref={ref}
        className={cn(
          'animate-spin rounded-full border-2 border-gray-300 border-t-blue-400',
          sizeClasses[size],
          className,
        )}
        {...props}
      />
    );
  },
);
Spinner.displayName = 'Spinner';

export {Spinner};
